const isItemWithId = (item) => item.id !== undefined;
const isGroupItem = (item) => item.type === 'group';
export function filterItemsByFlattenIds(items, ids) {
    const filteredItems = [];
    items.forEach(item => {
        if (isItemWithId(item) && item.id && ids.includes(item.id)) {
            filteredItems.push(item);
            return;
        }
        if (isGroupItem(item)) {
            const filteredSubItems = filterItemsByFlattenIds(item.items, ids);
            filteredItems.push(Object.assign(Object.assign({}, item), { items: filteredSubItems }));
            return;
        }
    });
    return filteredItems;
}
